module.exports = __webpack_public_path__ + "img/生活照料.3d94f871.png";